import React from "react";
import { Outlet } from "react-router-dom";
import { SidebarInset, SidebarProvider } from "../ui/sidebar";
import AppNavbar from "./AppNavbar";
import AppSidebar from "./AppSidebar";

/**
 * Chrome for every authenticated screen. Pages rendered through <Outlet /> are
 * responsible for their own content only — they must not render their own
 * navbar or sidebar.
 */
const DashboardLayout = () => {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0 bg-muted">
        <AppNavbar />
        <main className="flex-1 overflow-x-hidden px-5 py-6 lgss:px-8 lgss:py-8">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default DashboardLayout;
